import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './AdminHeader.css';

const AdminHeader = ({ title, onBack, showBackButton = false }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="header-left">
          {showBackButton && (
            <button onClick={onBack} className="back-btn">
              ← Voltar ao Painel
            </button>
          )}
          <h1>{title}</h1>
        </div>
        
        <div className="header-right">
          <div className="user-info">
            <div className="user-profile">
              {user?.photoURL ? (
                <img 
                  src={user.photoURL} 
                  alt="Profile" 
                  className="user-avatar"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div 
                className="user-avatar-fallback"
                style={{ display: user?.photoURL ? 'none' : 'flex' }}
              >
                {user?.username?.charAt(0)?.toUpperCase() || 'U'}
              </div>
            </div>
            <span className="user-greeting">Bem-vindo, {user?.username}</span>
            <button onClick={handleLogout} className="logout-button">
              Sair
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
